module.exports = __webpack_public_path__ + "img/logo.7f3f9bee.png";